/**
 * Shared utility for competition grouping in Autocomplete dropdowns.
 */
export function getCompGroup(name) {
  if (!name.includes('-')) return '🏆 European Competitions';
  const country = name.split('-')[0];
  if (['NBA', 'NCAA1', 'NCAA2'].includes(name) || country === 'NBA') return '🇺🇸 USA';
  return country;
}
